import { Injectable } from '@angular/core';
import { AbstractFeatureService } from '@y42/feature';
import { METADATA_JSON_SCHEMA_URL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { ToastService } from '@y42/toast';
import * as uuid from 'uuid';
import {
  CreateVisualizationFilterParams,
  VisualizationFilterGitService,
  VisualizationFilterQuery,
  VisualizationFilterState,
  VisualizationFilterStore,
  VisualizationFilterStoreModel,
} from '../../state/filter';
import { VisualizationTabQuery } from '../../state/tab';

@Injectable({ providedIn: 'root' })
export class VisualizationFilterService extends AbstractFeatureService<VisualizationFilterState> {
  constructor(
    protected readonly query: VisualizationFilterQuery,
    protected readonly store: VisualizationFilterStore,
    protected readonly toast: ToastService,
    protected readonly git: VisualizationFilterGitService,
    protected readonly gitQuery: GitQuery,
    protected readonly tabQuery: VisualizationTabQuery,
  ) {
    super({
      featureType: Y42FeatureType.VisualizationFilter,
      store,
      query,
      userData: null,
      git,
      gitQuery,
      toast,
      childStores: [],
    });
  }

  get(
    _$name: string,
    _options?: { writeToStore?: boolean | undefined; ignoreErrors?: boolean | undefined },
  ): Promise<VisualizationFilterStoreModel | null> {
    throw new Error('Method not implemented.');
  }

  async create({ settings }: CreateVisualizationFilterParams): Promise<VisualizationFilterStoreModel> {
    const $name = `${uuid.v4()}`;

    const filter = this.store.create({
      ...new Y42MetadataGitModel(),
      name: $name,
      $name,
      ...settings,
      $schema: METADATA_JSON_SCHEMA_URL,
    });

    await this.store.pending;

    return filter;
  }

  async duplicate(filter: VisualizationFilterStoreModel): Promise<VisualizationFilterStoreModel> {
    const $name = `${uuid.v4()}`;

    const newFilter = this.store.create({
      ...new Y42MetadataGitModel(),
      ...filter,
      name: $name,
      $name,
      $schema: METADATA_JSON_SCHEMA_URL,
    });

    await this.store.pending;

    return newFilter;
  }

  async update(model: Partial<VisualizationFilterStoreModel>, $path: string): Promise<void> {
    const skipSync = !this.tabQuery.getValue().ui.editMode;
    this.store.setSkipSync(skipSync);
    this.store.update($path, model);

    if (!skipSync) {
      await this.store.pending;
    }
    if (skipSync) {
      this.store.setSkipSync(false);
    }
  }

  async delete($path: string): Promise<void> {
    this.store.delete($path);
    await this.store.pending;

    // todo update parent? i dont know
  }
}
